import { OrderDetailsModel } from '../../../models';

export abstract class IOrderDetailsService {
  abstract getOrderDetails(voucherCode: string, country: string): Promise<OrderDetailsModel>;
  abstract getLastOrderDetails(): OrderDetailsModel | null;
}
